import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { useProject } from "../project";

export function useReorderWorkstreamsMutation() {
    const { project } = useProject();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (workstreamIds: string[]) => {
            await apiClient.reorderWorkstreams({
                params: { projectId: project.id },
                body: { workstreamIds },
            });
            await queryClient.refetchQueries({ queryKey: ["project", project.id] });
        },
    });
}
